(ns common.widgets.iframe.view
  "Component for displaying templates in a iframe."
  (:require ["react-use/lib/useEvent$default" :as useEvent]
            [common.widgets.iframe.db]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [uix.core :as uix :refer [defui $]]))

;;
;; Old component with re-frame state, avoid this.
;;

(defn iframe
  "IFrame component
  Creates an iframe and handles the initialization, waiting for messages, reloading and cleanup.

   The following properties can be passed as a map:
   | key                | description
   |--------------------|-----------------------------------------------------
   | `:id`              | A unique id for this iframe (important when a page has multiple iframes)
   | `:src`             | The source URL for the iframe
   | `:on-ready`        | The function to execute when the iframe is ready (usually an event that
   |                    | posts data to the iframe via the event :iframe/post-content-object)
   | `:class`           | Styling
   | `:height`          | Height
   | `:width`           | Width"
  {:deprecated true}
  [{:keys [id src class width height on-ready] :as props}]
  (r/create-class
   {:component-will-unmount #(rf/dispatch [:iframe/unregister id])
    :reagent-render
    (fn [_]
      [:iframe
       (merge (dissoc props :on-ready)
              {:src src
               :class class
               :width (js/parseInt width)
               :height (js/parseInt height)
               :ref (fn [ref]
                      (when ref
                        (rf/dispatch [:iframe/register {:ref ref :id id :on-ready on-ready}])))})])}))

;;
;; The new component doesn't use re-frame state, just the props.
;;

(defui iframe-new
  "Enchances iframe by adding window listener for `message` events in Window related to this
  iframe.
  When `lemonpi-awaiting-config` message is received, `:on-ready` callback is called with
  iframe element as parameter.

  You can use either the element from the on-ready callback or ref to control the
  iframe (reload, postMessage). You on-ready parameter if you need to control
  the iframe from that callback, and the ref you need to control iframe later.
  You probably shouldn't store the iframe element to app-db."
  [{:keys [ref on-ready] :as props}]
  (let [iframe-ref (uix/use-ref nil)
        set-refs (uix/use-callback (fn [x]
                                     (reset! iframe-ref x)
                                     (when ref
                                       (if (fn? ref)
                                         (ref x)
                                         (reset! ref x))))
                                   [ref])]
    ;; Message events are always received by the Window, so we need to filter
    ;; messages matching this specific iframe ourselve.
    (useEvent "message"
              (fn [e]
                (when (and @iframe-ref
                           (identical? (.-contentWindow @iframe-ref) (.-source e))
                           (= (.. e -data -type) "lemonpi-awaiting-config"))
                  (on-ready @iframe-ref)))
              js/window)
    ($ :iframe
       (assoc (dissoc props :on-ready)
              ;; merge refs
              :ref set-refs))))

(defn reload [iframe]
  (set! (.-src iframe) (.-src iframe)))

(defn post-lemonpi-config [iframe content-object]
  (.postMessage (.-contentWindow iframe)
                (clj->js {:type "lemonpi-config"
                          :config {:exportContent content-object}})
                "*"))
